/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_State_EndedInputs */



/**
* | output |
* | --- |
* | "The term ended {date}. This organization is now billed as an ordinary customer." |
*
* @param {Partner_Org_Contract_State_EndedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_state_ended = /** @type {((inputs: Partner_Org_Contract_State_EndedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_State_EndedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Laufzeit endete am ${i?.date}. Diese Organisation wird jetzt wie ein regulärer Kunde abgerechnet.`)
	return /** @type {LocalizedString} */ (`The term ended ${i?.date}. This organization is now billed as an ordinary customer.`)
});